import { Routes, Route } from "react-router-dom";
import Login from "./pages/auth/Login";
import Clients from "./pages/client/Clients";
import Produits from "./pages/produits/Produits";
import Commandes from "./pages/commandes/Commandes";
import AddProduit from "./pages/produits/AddProduit";
import AddCommande from "./pages/commandes/AddCommande";
import AddClient from "./pages/client/AddClient";
import Famille from "./pages/familles/Famille";
import SousFamille from "./pages/familles/SousFamille";
import { Toaster } from "react-hot-toast";
import ProductDetails from "./pages/produits/ProductDetails";
import UpdateProduit from "./pages/produits/UpdateProduit";
import ClientDetail from "./pages/client/ClientDetail";
import UpdateClient from "./pages/client/UpdateClient";
import CommandeDetail from "./pages/commandes/CommandeDetail";
import UpdateCommande from "./pages/commandes/UpdateCommande";
import FamilyProducts from "./pages/familles/FamilyProducts";
import SubFamilyProducts from "./pages/familles/SubFamilyProducts";
import Personnel from "./pages/employees/Personnel";
import AddPersonnel from "./pages/employees/AddPersonnel";
import PersonnelDetail from "./pages/employees/PersonnelDetail";
import UpdatePersonnel from "./pages/employees/UpdatePersonnel";
import Notifications from "./pages/notifications/Notifications";

function App() {
  // return (
  //   <>
  //     <Toaster />
  //     <div className="bg-[#fafafad9]">
  //       <Routes>
  //         <Route path="/crm/login" element={<Login />} />

  //         {/* Clients routes */}
  //         <Route path="/crm/" element={<Clients />} />
  //         <Route path="/crm/clients" element={<Clients />} />
  //         <Route path="/crm/client/add" element={<AddClient />} />
  //         <Route path="/crm/client/:id" element={<ClientDetail />} />
  //         <Route path="/crm/client/update/:id" element={<UpdateClient />} />

  //         {/* Produits routes */}
  //         <Route path="/crm/produits" element={<Produits />} />
  //         <Route path="/crm/produit/add" element={<AddProduit />} />
  //         <Route path="/crm/produit/:id" element={<ProductDetails />} />
  //         <Route path="/crm/produit/update/:id" element={<UpdateProduit />} />

  //         {/* Personnel routes */}
  //         <Route path="/crm/personnels" element={<Personnel />} />
  //         <Route path="/crm/personnel/add" element={<AddPersonnel />} />
  //         <Route path="/crm/personnel/:id" element={<PersonnelDetail />} />
  //         <Route
  //           path="/crm/personnel/update/:id"
  //           element={<UpdatePersonnel />}
  //         />

  //         {/* Commandes routes */}
  //         <Route path="/crm/commandes" element={<Commandes />} />
  //         <Route path="/crm/commande/add" element={<AddCommande />} />
  //         <Route path="/crm/commande/:id" element={<CommandeDetail />} />
  //         <Route path="/crm/commande/update/:id" element={<UpdateCommande />} />

  //         {/* familles routes */}
  //         <Route path="/crm/familles" element={<Famille />} />
  //         <Route path="/crm/sous-famille/:id" element={<SousFamille />} />
  //         <Route path="/crm/famille/produits" element={<FamilyProducts />} />
  //         <Route
  //           path="/crm/sous-famille/produits"
  //           element={<SubFamilyProducts />}
  //         />

  //         <Route path="/crm/notifications" element={<Notifications />} />
  //       </Routes>
  //     </div>
  //   </>
  // );

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        textAlign: "center",
        backgroundColor: "#fafafad9",
        padding: "20px",
        fontSize: "1.2rem",
        fontFamily: "sans-serif",
        lineHeight: "1.6",
      }}
    >
      <p style={{ maxWidth: "600px" }}>
        ⚠️ La période d’hébergement incluse dans votre garantie a expiré le 1er
        octobre.
        <br />
        <br />
        Votre service reste actuellement actif à titre exceptionnel, bien
        qu’aucun paiement n’ait été enregistré.
        <br />
        <br />
        Merci de régulariser la situation afin d’éviter toute suspension.
      </p>
    </div>
  );
}

export default App;
